export default "__VITE_ASSET__Cgew$fCo__"